import {
    USER_STROLLERS_SELECT_ENTER_SOME_CHARS,
    USER_STROLLERS_SELECT_NO_RESULTS,
    USER_STROLLERS_SELECT_SEARCHING,
} from 'mk/autogenerated/translations/UserStrollersWidgetSelect.7cee4d60a8efa940a1680a838876407d'
import { MobileDropdownAdapter } from 'mk/bzforms/mobileDropdown';
import 'mk/bzforms/select2.js';
import { jQuery as $ } from 'mk/jQuery';
import { strollers_api_suggest_strollers_url } from 'mk/urls/functions';

export const StrollersSelect = {
    init(selectElem, dropdownParent, placeholder, { allowClear = false } = {}) {
        const jQuerySelectElem = $(selectElem);
        jQuerySelectElem.select2({
            placeholder,
            dropdownParent,
            dropdownAdapter: MobileDropdownAdapter,
            language: {
                inputTooShort() {
                    return USER_STROLLERS_SELECT_ENTER_SOME_CHARS;
                },
                searching() {
                    return USER_STROLLERS_SELECT_SEARCHING;
                },
                noResults() {
                    return USER_STROLLERS_SELECT_NO_RESULTS;
                },
            },
            minimumInputLength: 2,
            ajax: {
                url: strollers_api_suggest_strollers_url(),
                dataType: 'json',
                delay: 250,
                data(params) {
                    return {
                        q: params.term,
                    };
                },
                processResults(data) {
                    return {
                        results: data,
                    };
                },
                cache: true,
            },
            escapeMarkup(m) { return m; },
            allowClear,
        });
    },
    processChangeEvent(jQueryEvent) {
        return { stroller_id: jQueryEvent.target.value, stroller_name: jQueryEvent.target.textContent };
    },
};
